import * as React from "react"
import { SelectAjaxSeeker } from "ui-seeker/core"
import { FORM_URL } from 'app/@common/constants'

export default function SelectLocationAccommodation({...props}) {

    const myProps = {
        urlAjax: FORM_URL.LOCATION_ACCOMMODATION,
        placeholder: 'Accommodation type',
        icon: {icon: 'bed'},
        isMulti: false,
        ...props
    }

    return <SelectAjaxSeeker {...myProps} />
}
